import { IPayrollChangeRequestState } from '@/store/payrollchangerequest';
import { IPayrollChangeRequestMutations } from './mutations.types';
import { IPayrollChangeRequestData, IUserData } from '@/models';
import { Transition } from '@/models/transition';

export const mutations: IPayrollChangeRequestMutations = {
  SET_COUNT(state: IPayrollChangeRequestState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IPayrollChangeRequestState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IPayrollChangeRequestState): void {
    state.count -= 1;
  },

  SET_PAYROLL_CHANGE_REQUESTS(
    state: IPayrollChangeRequestState,
    payload: IPayrollChangeRequestData[]
  ): void {
    state.payrollChangeRequests = payload;
  },

  ADD_PAYROLL_CHANGE_REQUEST(
    state: IPayrollChangeRequestState,
    payload: IPayrollChangeRequestData
  ): void {
    state.payrollChangeRequests.unshift(payload);
  },

  UPDATE_PAYROLL_CHANGE_REQUEST(
    state: IPayrollChangeRequestState,
    payload: IPayrollChangeRequestData
  ): void {
    const index = state.payrollChangeRequests.findIndex(
      (payrollChangeRequest: IPayrollChangeRequestData) =>
        payrollChangeRequest.id === payload.id
    );

    state.payrollChangeRequests.splice(index, 1, payload);
  },

  REMOVE_PAYROLL_CHANGE_REQUEST(
    state: IPayrollChangeRequestState,
    payload: number
  ): void {
    const index = state.payrollChangeRequests.findIndex(
      (payrollChangeRequest: IPayrollChangeRequestData) =>
        payrollChangeRequest.id === payload
    );

    state.payrollChangeRequests.splice(index, 1);
  },

  SET_PAYROLL_CHANGE_REQUEST_ACTIVITIES(
    state: IPayrollChangeRequestState,
    payload: Transition[]
  ): void {
    state.activities = payload;
  },

  //HR
  SET_PAYROLL_CHANGE_REQUEST_HR_PERSONNELS(
    state: IPayrollChangeRequestState,
    payload: IUserData[]
  ): void {
    state.hrPersonnels = payload;
  },

  SET_LAST_PROMISE(
    state: IPayrollChangeRequestState,
    payload: Promise<any>
  ): void {
    state.lastPromise = payload;
  }
};
